import { EMPTY_FILTERS, type CoverageFilter, type RosterFilters, type StatusFilter } from './types'

const ROLE_KEY = 'role'
const PERSON_KEY = 'person'
const STATUS_KEY = 'status'
const COVERAGE_KEY = 'coverage'

const STATUS_VALUES: StatusFilter[] = ['draft', 'published']
const COVERAGE_VALUES: CoverageFilter[] = ['needs', 'full']

type KnownOptions = {
  roles: string[]
  supporterIds: string[]
}

export const decodeFilters = (search: string, options: KnownOptions): RosterFilters => {
  const params = new URLSearchParams(search)

  const roles = params.getAll(ROLE_KEY).filter((role) => options.roles.includes(role))
  const people = params.getAll(PERSON_KEY).filter((id) => options.supporterIds.includes(id))

  const statusParam = params.get(STATUS_KEY)
  const status: StatusFilter = STATUS_VALUES.includes(statusParam as StatusFilter)
    ? (statusParam as StatusFilter)
    : 'all'

  const coverageParam = params.get(COVERAGE_KEY)
  const coverage: CoverageFilter = COVERAGE_VALUES.includes(coverageParam as CoverageFilter)
    ? (coverageParam as CoverageFilter)
    : 'any'

  return { roles, people, status, coverage }
}

export const applyFiltersToSearch = (search: string, filters: RosterFilters): string => {
  const params = new URLSearchParams(search)

  params.delete(ROLE_KEY)
  params.delete(PERSON_KEY)
  params.delete(STATUS_KEY)
  params.delete(COVERAGE_KEY)

  filters.roles.forEach((role) => params.append(ROLE_KEY, role))
  filters.people.forEach((id) => params.append(PERSON_KEY, id))
  if (filters.status !== EMPTY_FILTERS.status) params.set(STATUS_KEY, filters.status)
  if (filters.coverage !== EMPTY_FILTERS.coverage) params.set(COVERAGE_KEY, filters.coverage)

  return params.toString()
}
